import React, { useEffect } from "react";
import "./ConfirmModal.css";

/**
 * App-styled replacement for the native window.confirm() dialog.
 * Matches the existing modal look (see the Project Access modal).
 *
 * Props:
 *  - open: boolean
 *  - title, message: strings
 *  - confirmLabel, cancelLabel: button text
 *  - confirmVariant: "primary" (default) | "danger"
 *  - onConfirm, onCancel: callbacks
 */
const ConfirmModal = ({
  open,
  title = "Please confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "primary",
  onConfirm,
  onCancel,
}) => {
  // Escape closes the dialog, matching the app's other modals.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape" && onCancel) onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div
      className="cm-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onCancel}
    >
      <div className="cm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cm-header">
          <h3>{title}</h3>
          <button type="button" className="cm-close" onClick={onCancel} aria-label="Close">
            X
          </button>
        </div>
        <div className="cm-body">{message}</div>
        <div className="cm-footer">
          <button type="button" className="cm-btn cm-btn-cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`cm-btn cm-btn-confirm ${confirmVariant === "danger" ? "cm-btn-danger" : ""}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
